import Modal from '@mui/material/Modal'
import {CancelButton, SubmitButton, Text} from '../../1elements'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Paper from '@mui/material/Paper'
import ApproverSearch from '../../2compounds/ApproverSearch'
import { isAllowedToOverride, isAllowedToViewAdminAccess } from '../../../services/permissions/permissionHelper'
import OverrideApprovalButton from '../../1elements/Buttons/TextButtons/OverrideApprovalButton'

const useStyles = makeStyles({
    root: {
        padding: '20px',
        position: 'absolute',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        left: '50%',
        width: '600px',
    },
    buttonDiv: {
        display: 'flex',
        justifyContent: 'flex-end',

        '& .MuiButtonBase-root': {
            marginLeft: '30px'
        }
    },
    approverSearchField: {
        margin: '10px 0'
    }
})

const SelectApproverModal = ({isModalOpen, setIsModalOpen, className, onSubmit, setApprover, approver, showError, override, dashboard}) => {
    const classes = useStyles()
    const handleClose = () => {
        setIsModalOpen(false)
    }

    const handleSubmit = () => {
        handleClose()
        onSubmit()
    }

    return (
        <Modal open={isModalOpen} onClose={handleClose} className={className}>
            <Paper className={classes.root}>
                <Text type={'tabHeadingSecondary'}>Search and Select an approver name</Text>
                <ApproverSearch className={classes.approverSearchField} setApprover={setApprover} approver={approver}
                                showError={showError} dashboard={dashboard}/>

                <div className={classes.buttonDiv}>
                    {
                        (override && (isAllowedToOverride('approvals') || isAllowedToViewAdminAccess()) && (
                            <OverrideApprovalButton onClick={override} />
                        ))
                    }
                    <CancelButton onClick={handleClose} />
                    <SubmitButton onClick={handleSubmit} />
                </div>
            </Paper>
        </Modal>
    )
}

export default SelectApproverModal
